import { YesNoOptions } from "../../../../hooks/nimbus/useTable/useTable.definition";

export const BooleanRadioOptions = [
  { label: YesNoOptions.Yes, value: true },
  { label: YesNoOptions.No, value: false },
];
